/**
 * The calc engine's version, stamped onto every bid it produces.
 *
 * Kept in sync with packages/calc/package.json by a test, so a rate-affecting
 * change to the engine cannot ship without bumping this. A bid stores it so we
 * can tell whether an offline device quoted using an older engine build.
 *
 * Bump the MAJOR when the SHAPE of BidInput or BidResult changes, so a stored
 * result cannot be read by the other version's code at all. Bump the MINOR on any
 * change to how a price is computed. Bump the PATCH for changes that cannot move a
 * number (comments, refactors, new warnings).
 *
 * 2.0.0 is the all-package bid: one BidInput now yields a quote per package, so
 * `packageCode` left the input and `quotes` replaced the single top-level total.
 */
export const ENGINE_VERSION = '2.0.0';
